import React, { Component } from 'react';

import * as Sentry from '@sentry/react';

import { Link, Text } from '@nord/ui';

import TwoColView from '../templates/TwoColView';

interface IErrorBoundaryProps {
  logSentry: boolean;
  children?: React.ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

const handleClick = () => {
  window.location.reload();
};

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  public constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  public componentDidCatch(error: Error) {
    const { logSentry } = this.props;

    if (logSentry) {
      Sentry.captureException(error);
    }
  }

  public render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <TwoColView withoutImage>
          <h1 className="flex-auto text-center">
            <Text>
              We&apos;re sorry — something&apos;s gone wrong.
              <br /> Please{' '}
              <Link component="span" onClick={handleClick} underline>
                reload
              </Link>{' '}
              your browser
            </Text>
          </h1>
        </TwoColView>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
